import { defineMessages } from 'react-intl';

const messages = defineMessages({
  RelatedWorks: {
    defaultMessage: 'More like this',
    description: 'Heading for related works.'
  }
});

export default messages;
